import React from "react";
import clsx from "clsx";
import Button from "antd/lib/button";
import Tooltip from "antd/lib/tooltip";
import { PoweroffOutlined } from "@ant-design/icons";
import { Node as INode } from "Models/node";
import Line from "./Line";
import { BACKGROUND } from "Components/constants";
import Partition from "./Partition";
import { getNodePartitions } from "Services/nodes.service";
import styles from "./Node.module.css";

type NodeProps = {
    node: INode;
    toggleNode: (node: INode) => void;
};

const Node = ({ node, toggleNode }: NodeProps) => {
    const partitions = React.useMemo(
        () => getNodePartitions(node).sort((a, b) => a.id - b.id),
        [node]
    );

    return (
        <Tooltip title="Broker" placement="left">
            <div className={clsx(styles.root)}>
                <Button
                    type="primary"
                    className={styles.button}
                    onClick={() => toggleNode(node)}
                    icon={<PoweroffOutlined />}
                    danger={!node.active}
                />
                <Line
                    direction="vertical"
                    length={(partitions.length - 1) * 40}
                    className={styles.line}
                />
                <div className={styles.partitions}>
                    {partitions.map((partition) => (
                        <Partition
                            logUid={partition.logUid}
                            key={partition.logUid}
                        />
                    ))}
                </div>
                <div
                    className={clsx(styles.overlay, {
                        [styles.disabled]: !node.active,
                    })}
                    style={{
                        backgroundColor: `#${BACKGROUND?.toString(16)}`,
                    }}
                />
            </div>
        </Tooltip>
    );
};

export default Node;
